export type InFlightRequestKey = string | number | null | undefined

function normalizeInFlightRequestKey(key: InFlightRequestKey): string | null {
    if (key == null) return null

    const normalizedKey = String(key)
    return normalizedKey ? normalizedKey : null
}

export function runInFlightRequest<T>(
    pendingRequests: Map<string, Promise<T>>,
    key: InFlightRequestKey,
    requestFactory: () => Promise<T>,
): Promise<T> {
    const normalizedKey = normalizeInFlightRequestKey(key)
    if (!normalizedKey) return requestFactory()

    const existingRequest = pendingRequests.get(normalizedKey)
    if (existingRequest) return existingRequest

    const request = Promise.resolve().then(requestFactory)
    pendingRequests.set(normalizedKey, request)

    const clearRequest = () => {
        if (pendingRequests.get(normalizedKey) === request) {
            pendingRequests.delete(normalizedKey)
        }
    }

    request.then(clearRequest, clearRequest)
    return request
}
